(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-technical-specs"] && !Shopify.designMode) return;
  try {
    
  class ProductSpecsSku extends HTMLElement {
    connectedCallback() {
      this.onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('variant:change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariantChange);
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;

      const sku = variant.sku || '';
      const row = this.querySelector('[data-product-specs-sku-row]');
      const value = this.querySelector('[data-product-specs-sku]');

      if (value) value.textContent = sku;
      if (row) row.hidden = sku === '';
    }
  }

  if (!customElements.get('product-specs-sku')) {
    customElements.define('product-specs-sku', ProductSpecsSku);
  }

  } catch(e) { console.error(e); }
})();
})();
